import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../wayfinder'
import cases5f0c2e from './cases'
import users48860f from './users'
import topicsBc3fb2 from './topics'
import schedule7539d9 from './schedule'
import settings69f00b from './settings'
/**
* @see \App\Actions\Admin\GetAdminCaseList::__invoke
* @see app/Actions/Admin/GetAdminCaseList.php:17
* @route '/admin/cases'
*/
export const cases = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: cases.url(options),
    method: 'get',
})

cases.definition = {
    methods: ["get","head"],
    url: '/admin/cases',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Actions\Admin\GetAdminCaseList::__invoke
* @see app/Actions/Admin/GetAdminCaseList.php:17
* @route '/admin/cases'
*/
cases.url = (options?: RouteQueryOptions) => {
    return cases.definition.url + queryParams(options)
}

/**
* @see \App\Actions\Admin\GetAdminCaseList::__invoke
* @see app/Actions/Admin/GetAdminCaseList.php:17
* @route '/admin/cases'
*/
cases.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: cases.url(options),
    method: 'get',
})

/**
* @see \App\Actions\Admin\GetAdminCaseList::__invoke
* @see app/Actions/Admin/GetAdminCaseList.php:17
* @route '/admin/cases'
*/
cases.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: cases.url(options),
    method: 'head',
})

/**
* @see \App\Actions\Admin\GetUserList::__invoke
* @see app/Actions/Admin/GetUserList.php:17
* @route '/admin/users'
*/
export const users = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: users.url(options),
    method: 'get',
})

users.definition = {
    methods: ["get","head"],
    url: '/admin/users',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Actions\Admin\GetUserList::__invoke
* @see app/Actions/Admin/GetUserList.php:17
* @route '/admin/users'
*/
users.url = (options?: RouteQueryOptions) => {
    return users.definition.url + queryParams(options)
}

/**
* @see \App\Actions\Admin\GetUserList::__invoke
* @see app/Actions/Admin/GetUserList.php:17
* @route '/admin/users'
*/
users.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: users.url(options),
    method: 'get',
})

/**
* @see \App\Actions\Admin\GetUserList::__invoke
* @see app/Actions/Admin/GetUserList.php:17
* @route '/admin/users'
*/
users.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: users.url(options),
    method: 'head',
})

/**
* @see \App\Actions\Admin\GetAnalytics::__invoke
* @see app/Actions/Admin/GetAnalytics.php:17
* @route '/admin'
*/
export const dashboard = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: dashboard.url(options),
    method: 'get',
})

dashboard.definition = {
    methods: ["get","head"],
    url: '/admin',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Actions\Admin\GetAnalytics::__invoke
* @see app/Actions/Admin/GetAnalytics.php:17
* @route '/admin'
*/
dashboard.url = (options?: RouteQueryOptions) => {
    return dashboard.definition.url + queryParams(options)
}

/**
* @see \App\Actions\Admin\GetAnalytics::__invoke
* @see app/Actions/Admin/GetAnalytics.php:17
* @route '/admin'
*/
dashboard.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: dashboard.url(options),
    method: 'get',
})

/**
* @see \App\Actions\Admin\GetAnalytics::__invoke
* @see app/Actions/Admin/GetAnalytics.php:17
* @route '/admin'
*/
dashboard.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: dashboard.url(options),
    method: 'head',
})

/**
* @see \App\Actions\Admin\GetTopics::__invoke
* @see app/Actions/Admin/GetTopics.php:17
* @route '/admin/topics'
*/
export const topics = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: topics.url(options),
    method: 'get',
})

topics.definition = {
    methods: ["get","head"],
    url: '/admin/topics',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Actions\Admin\GetTopics::__invoke
* @see app/Actions/Admin/GetTopics.php:17
* @route '/admin/topics'
*/
topics.url = (options?: RouteQueryOptions) => {
    return topics.definition.url + queryParams(options)
}

/**
* @see \App\Actions\Admin\GetTopics::__invoke
* @see app/Actions/Admin/GetTopics.php:17
* @route '/admin/topics'
*/
topics.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: topics.url(options),
    method: 'get',
})

/**
* @see \App\Actions\Admin\GetTopics::__invoke
* @see app/Actions/Admin/GetTopics.php:17
* @route '/admin/topics'
*/
topics.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: topics.url(options),
    method: 'head',
})

/**
* @see \App\Actions\Admin\GetSchedule::__invoke
* @see app/Actions/Admin/GetSchedule.php:17
* @route '/admin/schedule'
*/
export const schedule = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: schedule.url(options),
    method: 'get',
})

schedule.definition = {
    methods: ["get","head"],
    url: '/admin/schedule',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Actions\Admin\GetSchedule::__invoke
* @see app/Actions/Admin/GetSchedule.php:17
* @route '/admin/schedule'
*/
schedule.url = (options?: RouteQueryOptions) => {
    return schedule.definition.url + queryParams(options)
}

/**
* @see \App\Actions\Admin\GetSchedule::__invoke
* @see app/Actions/Admin/GetSchedule.php:17
* @route '/admin/schedule'
*/
schedule.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: schedule.url(options),
    method: 'get',
})

/**
* @see \App\Actions\Admin\GetSchedule::__invoke
* @see app/Actions/Admin/GetSchedule.php:17
* @route '/admin/schedule'
*/
schedule.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: schedule.url(options),
    method: 'head',
})

/**
* @see \App\Actions\Admin\GetSettings::__invoke
* @see app/Actions/Admin/GetSettings.php:17
* @route '/admin/settings'
*/
export const settings = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: settings.url(options),
    method: 'get',
})

settings.definition = {
    methods: ["get","head"],
    url: '/admin/settings',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Actions\Admin\GetSettings::__invoke
* @see app/Actions/Admin/GetSettings.php:17
* @route '/admin/settings'
*/
settings.url = (options?: RouteQueryOptions) => {
    return settings.definition.url + queryParams(options)
}

/**
* @see \App\Actions\Admin\GetSettings::__invoke
* @see app/Actions/Admin/GetSettings.php:17
* @route '/admin/settings'
*/
settings.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: settings.url(options),
    method: 'get',
})

/**
* @see \App\Actions\Admin\GetSettings::__invoke
* @see app/Actions/Admin/GetSettings.php:17
* @route '/admin/settings'
*/
settings.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: settings.url(options),
    method: 'head',
})

const admin = {
    cases: Object.assign(cases, cases5f0c2e),
    users: Object.assign(users, users48860f),
    dashboard: Object.assign(dashboard, dashboard),
    topics: Object.assign(topics, topicsBc3fb2),
    schedule: Object.assign(schedule, schedule7539d9),
    settings: Object.assign(settings, settings69f00b),
}

export default admin